export const gameLevel = {
  easy: {
    rows: 8,
    cols: 10,
    mines: 10
  },
  normal: {
    rows: 14,
    cols: 18,
    mines: 40
  },
  hard: {
    rows: 20,
    cols: 24,
    mines: 99
  }
}

export const defaultLevel = {
  rows: 14,
  cols: 18,
  mines: 40  
}